import { useEffect, useState } from 'react';
import createSingleI18nProvider from 'I18n/init/providers/createSingleI18nProvider';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
const logTranslationError = err => console.error('[interactive-cards] Failed to load translations:', err);
let provider;
let isRegistered = false;
function getOrCreateProvider() {
  if (!provider) {
    provider = createSingleI18nProvider({
      language: getLangLocale()
    });
  }
  return provider;
}
export function useLoadTranslations(locale) {
  const [loaded, setLoaded] = useState(isRegistered);
  useEffect(() => {
    if (loaded) return;
    let cancelled = false;
    import( /* webpackMode: "eager" */'i2l?query=interactive-cards!interactive-cards/lang/en.lyaml').then(langModule => getOrCreateProvider().register(langModule.default)).then(() => {
      isRegistered = true;
      if (!cancelled) setLoaded(true);
    }).catch(err => {
      logTranslationError(err);
      if (!cancelled) setLoaded(true);
    });
    return () => {
      cancelled = true;
    };
  }, [loaded, locale]);
  return loaded;
}
export async function setupTranslationsForTesting() {
  const langModule = await import( /* webpackMode: "eager" */'i2l?query=interactive-cards!interactive-cards/lang/en.lyaml');
  await getOrCreateProvider().register(langModule.default);
  isRegistered = true;
}
export async function setupTranslationsForStorybook() {
  const i18nProvider = createStandardI18nProvider();
  i18nProvider.setLocale({
    locale: 'en',
    langEnabled: false
  });
  const langModule = await import( /* webpackMode: "eager" */'i2l?query=interactive-cards!interactive-cards/lang/en.lyaml');
  await i18nProvider.register(langModule.default);
  isRegistered = true;
}
export function __resetProviderForTesting() {
  provider = undefined;
  isRegistered = false;
}